<style lang="scss">



@media screen and (min-width: 55rem) {
  .CatStoreIntroduction-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    margin-top: 5rem;
    .CatStoreIntroduction-content {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      .CatStoreIntroduction-left {
        width: 60%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .CatStoreIntroduction-left-title {
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 1.6rem;
          height: 2rem;
        }

        .CatStoreIntroduction-left-line {
          width: 1.6rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 2rem;
          margin-top: 1rem;
        }

        .CatStoreIntroduction-left-text {
          width: 90%;
          font-size: 1.2rem;
          color: #7f7f7f;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
      }
      .CatStoreIntroduction-right {
        width: 30%;
        height: 110%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .CatStoreIntroduction-picture {
          margin-top: 2rem;
          width: 100%;
          height: 100%;
          background-image: url("/media/yintai/cat-title-1.png");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          box-shadow: -5px 3px 3px #d4d2d2;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .CatStoreIntroduction-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    .CatStoreIntroduction-content {
      width: 80%;
      display: flex;
      flex-direction: column-reverse;
      align-content: center;
      .CatStoreIntroduction-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .CatStoreIntroduction-left-title {
          // background-image: url("/media/yintai/svg/intime365.svg");
          width: 9rem;
          height: 2rem;
          background-size: 100% 100%;
          margin-top: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 1.6rem;
          height: 2rem;
        }

        .CatStoreIntroduction-left-line {
          width: 2rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 3rem;
          margin-top: 1rem;
        }

        .CatStoreIntroduction-left-text {
          width: 100%;
          font-size: 1.2rem;
          color: #7f7f7f;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
      }
      .CatStoreIntroduction-right {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .CatStoreIntroduction-picture {
          margin-top: 2rem;
          width: 100%;
          height: 25rem;
          box-shadow: -5px 3px 3px #d4d2d2;

          background-image: url("/media/yintai/cat-title-1.png");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>

<template>
  <div class="CatStoreIntroduction-container">
    <div class="CatStoreIntroduction-content">
      <div class="CatStoreIntroduction-left">
        <div class="CatStoreIntroduction-left-title">{{ "喵 街" }}</div>
        <div class="CatStoreIntroduction-left-line"></div>
        <div class="CatStoreIntroduction-left-text">
          2015年，国内传统零售业还未有规模化的线上聚合平台，中国线下商业生态缺乏完善的信用体系，也缺乏线上运营能力，于是，喵街应运而生。<br />
          目前，喵街已将银泰百货全国的线下商场都数字化至APP，实现商品数字化、权益数字化、导购员数字化、服务数字化、内容数字化。逛街消费不拎袋、口红当作外卖点、会员积分当钱花，喵街上的这些体验，堪称银泰百货新零售五年，为城市生活消费带来的最大改变。<br />
          在银泰百货逛街，选择恐惧症用户不用跑回头路，只需将心仪的货品通过喵街app加入购物车，在挑选完成后直接下单，即可24小时内发货包邮到家，告别提着大包小包逛街的臃肿负重。同时，银泰百货推出的定时达服务，让用户足不出户，专柜货躺着就能买。这背后也是银泰新零售数字化能力的体现：通过千万级货品的数字化，实现线上线下无差别的购物体验。<br />
          银泰百货会员体系也将进一步升级，以后在喵街app购买商品，也可以实现一键积分，再也无需去专柜跑一趟。接下来，喵街还将围绕导购员，拓展线上更多元的用户体验场景，让用户感受到，不管多远，商场尽在眼前。
        </div>
      </div>

      <div class="CatStoreIntroduction-right">
        <div class="CatStoreIntroduction-picture"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatStoreIntroduction",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
